module.exports = __webpack_public_path__ + "static/img/icon_error.c8979bf0.png";